/**
 * External dependencies
 */
import { useEffect, useState } from '@wordpress/element';
import { registerPaymentMethod } from '@woocommerce/blocks-registry';
import { __ } from '@wordpress/i18n';
import { getSetting } from '@woocommerce/settings';
import { decodeEntities } from '@wordpress/html-entities';
import { dispatch } from '@wordpress/data';

const settings = getSetting('grow-wallet-payment_data', {});
const defaultLabel = __('Grow Wallet', 'meshulam-payment-gateway');

const label = decodeEntities(settings.title) || defaultLabel;
const { CHECKOUT_STORE_KEY } = window.wc.wcBlocksData;
let redirect = "";
let new_order_id = "";
let currentOrderId = '';

const Content = (props) => {
    const { eventRegistration, emitResponse } = props;
    const { onCheckoutSuccess, onPaymentSetup } = eventRegistration;

    useEffect(() => {

        const processing = onPaymentSetup(async () => {
            const meshulam_pay_exp_type = $(".wc-block-checkout__form [name='meshulam_pay_exp_type']").val();
            const meshulam_pay_exp_numpayment = $(".wc-block-checkout__form [name='meshulam_pay_exp_numpayment']").val();
            const meshulam_pay_exp_numpayment_debit = $(".wc-block-checkout__form [name='meshulam_pay_exp_numpayment_debit']").val();

            if (meshulam_pay_exp_type || meshulam_pay_exp_numpayment || meshulam_pay_exp_numpayment_debit) {
                return {
                    type: emitResponse.responseTypes.SUCCESS,
                    meta: {
                        paymentMethodData: {
                            meshulam_pay_exp_type,
                            meshulam_pay_exp_numpayment,
                            meshulam_pay_exp_numpayment_debit
                        },
                    },
                };
            }
        });

        const unsubscribe = onCheckoutSuccess(async (data) => {

            if (!currentOrderId) {
                console.error("Order ID is missing");
                return;
            }

            try {
                const response = await fetch(settings.ajax_url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams({
                        order_id: currentOrderId,
                        action: "meshulam_grow_wallet_iframe"
                    })
                });

                const result = await response.json();

                if (!result || result === 'false') {
                    dispatch('core/notices').createErrorNotice(
                        __('There was an error processing your payment. Please try again.', 'meshulam-payment-gateway'),
                        { context: 'wc/checkout' }
                    );

                    return { type: emitResponse.responseTypes.ERROR };
                }

                if (result.error) {
                    dispatch('core/notices').createErrorNotice(
                        result.error,
                        { context: 'wc/checkout' }
                    );
                    return { type: emitResponse.responseTypes.ERROR };
                }

                growPayment.renderPaymentOptions(result.token);
                redirect = result.thank_you_url;
                new_order_id = currentOrderId;

            } catch (error) {
                console.error("Error:", error);
                dispatch('core/notices').createErrorNotice(
                    __('An unexpected error occurred. Please try again.', 'meshulam-payment-gateway'),
                    { context: 'wc/checkout' }
                );
            }
        });

        return () => {
            processing();
            unsubscribe();
        };
    }, [
        emitResponse.responseTypes.ERROR,
        emitResponse.responseTypes.SUCCESS,
        onPaymentSetup,
        onCheckoutSuccess
    ]);

    // Load Meshulam SDK
    useEffect(() => {
        (function () {
            const s = document.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = "https://cdn.meshulam.co.il/sdk/gs.min.js";
            s.onload = configureGrowSdk;
            const x = document.getElementsByTagName("script")[0];
            x.parentNode.insertBefore(s, x);
        })();
    }, []);

    // Fetch override to get order ID safely (works better on iPhone)
    useEffect(() => {
        const originalFetch = window.fetch;
        window.fetch = async function (...args) {
            const response = await originalFetch(...args);
            const clonedResponse = response.clone();
            if (args[0].includes('/wp-json/wc/store/v1/checkout')) {
                try {
                    const data = await clonedResponse.json();
                    if (data.order_id) {
                        currentOrderId = data.order_id;
                    }
                } catch (error) {
                }
            }
            return response;
        };

        return () => {
            window.fetch = originalFetch;
        };
    }, []);

    return (
        <div dangerouslySetInnerHTML={{ __html: settings.payment_fields }}></div>
    );
}

const configureGrowSdk = () => {
    let bank_transfer_redirect = false;
    let config = {
        environment: settings.mode,
        version: "1.0",
        events: {
            onSuccess: (response) => {
                console.log("onSuccess");
                console.log(response);

                if (redirect) {
                    window.location.replace(redirect);
                }
            },
            onFailure: (response) => {
                console.log("onFailure");
                console.log(response);
            },
            onError: (response) => {
                console.log("onError");
                console.log(response);
            },
            onTimeout: (response) => {
                console.log("onTimeout");
                console.log(response);
            },
            onWalletChange: (state) => {
                console.log("onWalletChange");
                console.log(state);

                if (state === 'close') {
                    unblockBlockCheckout();
                    if (bank_transfer_redirect && redirect) {
                        window.location.replace(redirect);
                    }
                }

            },
            onPaymentStart: (response) => {
                console.log("onPaymentStart");
                console.log(response);

                if (response.paymentName == 'bank_transfer') {
                    bank_transfer_redirect = true;
                    if (response.paymentType) {
                        set_payment_method_name(response.paymentType, new_order_id);
                    }
                }

            },
            onPaymentCancel: (response) => {
                console.log("onPaymentCancel");
                console.log(response);
            },
            onBankTransferStarted: (response) => {
                console.log("onBankTransferStarted");
                console.log(response);
            },

        }
    };

    growPayment.init(config);
}


const unblockBlockCheckout = () => {
    if (typeof wcSettings === 'undefined' || !wcSettings.wcBlocksConfig) {
        return;
    }

    const checkoutStore = dispatch(CHECKOUT_STORE_KEY);
    checkoutStore.__internalSetRedirectUrl(null);
    checkoutStore.__internalSetIdle();

    const { PAYMENT_STORE_KEY } = window.wc.wcBlocksData;
    dispatch(PAYMENT_STORE_KEY).__internalSetPaymentIdle();
}

const Icon = () => {
    return settings.icon ? <div dangerouslySetInnerHTML={{ __html: settings.icon }}></div> : null;
}

const Label = () => {
    return (
        <span className="icon_label">
            <span>{label}</span>
            <Icon />
        </span>
    );
}

const walletPaymentMethod = {
    name: settings.name,
    label: <Label />,
    placeOrderButtonLabel: settings.button_title,
    content: <Content />,
    edit: <Content />,
    canMakePayment: () => true,
    ariaLabel: label,
    supports: {
        features: settings.supports ?? [],
    },
}

registerPaymentMethod(walletPaymentMethod);
